// extracted by mini-css-extract-plugin
module.exports = {"drawer":"Open_drawer__-V9je","deleteCalendars":"Open_deleteCalendars__2NME7","addManually":"Open_addManually__n1Zmj","addingManually":"Open_addingManually__2l055"};